import React from 'react'
import Header from '../Home/Header'
import Section1 from './Section1'
import Footer from '../Home/Footer'
export default function IndexPersonalform() {
  return (
    <div>
        <Header/>
        <Section1/>
        <Footer/>
     
    </div>
  )
}
